import axios from './axios-auth';

const getAllCustomers = async ({ current, pageSize, sortField, sortOrder, searchTerm }) => {
  try {
    const { data } = await axios.get(
      `/dv-adm/getallcustomers?searchTerm=${searchTerm}&pageNumber=${current}&pageSize=${pageSize}&sortField=${sortField}&sortOrder=${sortOrder}&user_type=0&lock_status_type=2`
    );
    return data;
  } catch (e) {
    console.log(e);
  }
};

const getCustomerById = (customerId) =>
  new Promise((resolve, reject) => {
    axios({
      url: `/dv-adm/getcustomerbyid?id=${customerId}`,
      method: 'GET',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error while fetching unit types api');
      });
  });

const getUnassociatedClients = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/dv-adm/getclientsfordvadmin',
      method: 'GET',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error while fetching unit types api');
      });
  });

const updateCustomer = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: `/dv-adm/updatecustomerbyid`,
      method: 'PUT',
      data: payload,
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get tax reporting database report api');
      });
  });
const addCustomer = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: `/dv-adm/addcustomer`,
      method: 'POST',
      data: payload,
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get tax reporting database report api');
      });
  });
const deleteCustomer = ({ customerId }) =>
  new Promise((resolve, reject) => {
    axios({
      url: `/dv-adm/deletecustomerbyid?customerId=${customerId}`,
      method: 'DELETE',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get tax reporting database report api');
      });
  });
export { getAllCustomers, getCustomerById, getUnassociatedClients, updateCustomer, addCustomer, deleteCustomer };
